module.exports = __webpack_public_path__ + "carousel-grey-2.f717bfa5c7f61e34c365411a4211956a.jpg";